
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as kontaktdo94YlvSVAXRtL7_45mctFPDENZIO_456iuSagwdy8hZ6xcMeta } from "/workspace/pages/kontakt.vue?macro=true";
import { default as _91page_93OcCX9hIbyMWS_45iv7AvGRWdHjtTwBQSOUdJafucxxvbwMeta } from "/workspace/pages/[dir]/[page].vue?macro=true";
import { default as eventpq0ek8bYpqWy_ZfrdH4iNjCeFr75cQKw9x1n__m9JhIMeta } from "/workspace/pages/intern/event.vue?macro=true";
import { default as UnauthorizedMsqsa5J2g_bZavTuEWFXrXqYHnNZEUyXGhztu7tlojcMeta } from "/workspace/pages/Unauthorized.vue?macro=true";
import { default as start6ollaZ9j__45ZkhCIHR_45wnk2eFjrsMblt9dAQ8pUfcPeYMeta } from "/workspace/pages/dashboard/start.vue?macro=true";
import { default as mailing7kpso8yTn4_45P1Y0m5xcBB_45eIKT0dsgrE9C8TthsC1ZwMeta } from "/workspace/pages/dashboard/mailing.vue?macro=true";
import { default as unfallHu_45Ub7NKmpCn5_cdW7_450zrvC3FlQEpDS7oxxuAb_JFUMeta } from "/workspace/pages/statistiken/unfall.vue?macro=true";
import { default as Aktivierungr_45eI30WjW_oUGJecOm1qegT4Ge6G5dU_45K2V41rmlru8Meta } from "/workspace/pages/digital/Aktivierung.vue?macro=true";
import { default as Betriebsliga_xzF4iQlek7O_ZY1R991V2_F8sXb7eOuHPEMYnU3WtsMeta } from "/workspace/pages/digital/Betriebsliga.vue?macro=true";
import { default as personaleivkErTPvZFAXssRgou8qfXNCpw_RNpk6hDZwJ3zSckMeta } from "/workspace/pages/statistiken/personal.vue?macro=true";
import { default as fuhrparkinfooHF868JF99WT_45WixnbzkIMPcxy2xqc8FOHhvyYsr4UgMeta } from "/workspace/pages/fuhrpark/fuhrparkinfo.vue?macro=true";
import { default as produktivxMwsqxVCNoOUFa4UQtAiWGB__459ONIgoFsyWHzDRlW7cMeta } from "/workspace/pages/statistiken/produktiv.vue?macro=true";
import { default as telefonliste30y6p0CbMDYSQO8NxlOcHViXDiS8rgdG4TqHQXiuBN4Meta } from "/workspace/pages/dashboard/telefonliste.vue?macro=true";
import { default as LohnabrechnungduxBgaTXygXINsvIQJn_450kx8jwzpGM8vfYa0SbRVrSwMeta } from "/workspace/pages/digital/Lohnabrechnung.vue?macro=true";
import { default as prueflistepoLz6BxlLqQ5QAxvY2NEP3NgPac7lPgDTZYdnTvKdSAMeta } from "/workspace/pages/statistiken/pruefliste.vue?macro=true";
import { default as personaleventIQoSccGPvYaVa1y27tjP3QDop1TtNcRBmdu0xpIqyT8Meta } from "/workspace/pages/dashboard/personalevent.vue?macro=true";
import { default as bewerber_Statuswe50h02afLjnxYeo15a4b_wRrvByR_oyUj1GVB7_yyYMeta } from "/workspace/pages/digital/bewerber_Status.vue?macro=true";
import { default as bewerber_45Tabletsg4cn1WbTci7JQ_lM6I2gLT6nXIZbNB_45OkZ6hgl4lQkwMeta } from "/workspace/pages/digital/bewerber-Tablets.vue?macro=true";
import { default as myTempton_45urlaubPh3SSxGGk_45wHHXOnPTZSaMQVSh5RA54PLMudNwMfnBMMeta } from "/workspace/pages/digital/myTempton-urlaub.vue?macro=true";
import { default as PersonalAbteilung5l6EShvBGZNa1vbG7iDvIWQbOb14KsHRsHtqfUpvv4oMeta } from "/workspace/pages/intern/PersonalAbteilung.vue?macro=true";
import { default as besichtigungcuNwUfXNBz_ap8w1nJKSv5Xr2yzOyBZ2146vr2W3Mw4Meta } from "/workspace/pages/arbeitsplatz/besichtigung.vue?macro=true";
import { default as niederlassungeno7ddS90A_z4x1ok64xosrw8YWbz_jmk64GyzgMt632QMeta } from "/workspace/pages/dashboard/niederlassungen.vue?macro=true";
import { default as BundeseinheitlichyuT5hpzac0h0jXWCTzTMpTUMCeFwutBS7CPHgPphP8EMeta } from "/workspace/pages/digital/Bundeseinheitlich.vue?macro=true";
import { default as myTempton_45Nutzung6chS3mv3_45hce9xm5pL2U1LzfxsLiXuax6pS8elCHUMUMeta } from "/workspace/pages/digital/myTempton-Nutzung.vue?macro=true";
import { default as Personaluebersichts7gVvFMfXwK4a_45GIUayfgvU2UmVbh6N6uQFJSV2xpCYMeta } from "/workspace/pages/intern/Personaluebersicht.vue?macro=true";
import { default as arbeitszeitkonto3owQWsc8q2ZVxFzWow1wHNDFAKYIBWyU1NJdc_45l_454DEMeta } from "/workspace/pages/dashboard/arbeitszeitkonto.vue?macro=true";
import { default as bewerber_UebersichtlMxuaj3R7lBQ1eUdTEX_sJo7xE3Dbzl0e9_45J27T4v6IMeta } from "/workspace/pages/digital/bewerber_Uebersicht.vue?macro=true";
import { default as bewerber_45MitarbeiteraHJW6t0W_45n1Wv4d5Y7d6ZZkB9ktrSj6uzm9XRF4Hab8Meta } from "/workspace/pages/digital/bewerber-Mitarbeiter.vue?macro=true";
import { default as ElektronischeanfrageBueuz_45_z_91MfDWTCxwBSgL8rNaYpXFxaftDjPHQfB4Meta } from "/workspace/pages/digital/Elektronischeanfrage.vue?macro=true";
import { default as werksarztzentrumJXZLt_45J4c67kIHsAMGhmkPv9KmLFJBUqMzsa_GHV2vsMeta } from "/workspace/pages/statistiken/werksarztzentrum.vue?macro=true";
import { default as myTempton_45TransponderK_NDtZDHWWEZMl_452XItEUlATidbLod9R7FteKc9SSWUMeta } from "/workspace/pages/digital/myTempton-Transponder.vue?macro=true";
import { default as tempton_45connect_45eventD3tbotGqzprRWFdP71Z_459X_45Gx2otSKbYjK3uQObYn58Meta } from "/workspace/pages/digital/tempton-connect-event.vue?macro=true";
import { default as vertriebsstatistikFQQ6T71swdmfM1_YYY4DzJQ3dhb_45_t_45mtcQF_45ASwEK0Meta } from "/workspace/pages/statistiken/vertriebsstatistik.vue?macro=true";
import { default as vertriebsvergleichmPqT_45Fi11CqIQ2bkEsFYK31P8Ybn_P3JOFJTTKdmoxsMeta } from "/workspace/pages/statistiken/vertriebsvergleich.vue?macro=true";
import { default as vertriebuebersicht4ldV5o8_45avp5W8VrOcHczXVgpp3C8K8CttMApeeGP6EMeta } from "/workspace/pages/statistiken/vertriebuebersicht.vue?macro=true";
import { default as myTempton_45zeiterfassunguRjSs9Vk8xoHJiwJOgLZR7BiGqxshmZuqvZ0fTP81HYMeta } from "/workspace/pages/digital/myTempton-zeiterfassung.vue?macro=true";
import { default as pruefliste_fehlerliste1KY_h0v3qLJMlspO40uw_45CHSmJH6_45hR62N33JGw4rpQMeta } from "/workspace/pages/statistiken/pruefliste_fehlerliste.vue?macro=true";
import { default as bewerber_45Mitarbeiter_EinstellyB7eC9zUJgiQwXCM2P5LloAzFQM2M1EySJNESEsKgs8Meta } from "/workspace/pages/digital/bewerber-Mitarbeiter_Einstell.vue?macro=true";
import { default as bewerber_45Mitarbeiter_bewerbungW2xWHG0Sjhyydfr_459UurJ5cw5HzAElJDlLR5PbOMKTAMeta } from "/workspace/pages/digital/bewerber-Mitarbeiter_bewerbung.vue?macro=true";
export default [
  {
    name: "index___de",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "kontakt___de",
    path: "/kontakt",
    component: () => import("/workspace/pages/kontakt.vue")
  },
  {
    name: "dir-page___de",
    path: "/:dir()/:page()",
    component: () => import("/workspace/pages/[dir]/[page].vue")
  },
  {
    name: "intern-event___de",
    path: "/intern/event",
    meta: eventpq0ek8bYpqWy_ZfrdH4iNjCeFr75cQKw9x1n__m9JhIMeta || {},
    component: () => import("/workspace/pages/intern/event.vue")
  },
  {
    name: "Unauthorized___de",
    path: "/Unauthorized",
    component: () => import("/workspace/pages/Unauthorized.vue")
  },
  {
    name: "dashboard-start___de",
    path: "/dashboard/start",
    component: () => import("/workspace/pages/dashboard/start.vue")
  },
  {
    name: "dashboard-mailing___de",
    path: "/dashboard/mailing",
    component: () => import("/workspace/pages/dashboard/mailing.vue")
  },
  {
    name: "statistiken-unfall___de",
    path: "/statistiken/unfall",
    component: () => import("/workspace/pages/statistiken/unfall.vue")
  },
  {
    name: "digital-Aktivierung___de",
    path: "/digital/Aktivierung",
    component: () => import("/workspace/pages/digital/Aktivierung.vue")
  },
  {
    name: "digital-Betriebsliga___de",
    path: "/digital/Betriebsliga",
    component: () => import("/workspace/pages/digital/Betriebsliga.vue")
  },
  {
    name: "statistiken-personal___de",
    path: "/statistiken/personal",
    component: () => import("/workspace/pages/statistiken/personal.vue")
  },
  {
    name: "fuhrpark-fuhrparkinfo___de",
    path: "/fuhrpark/fuhrparkinfo",
    meta: fuhrparkinfooHF868JF99WT_45WixnbzkIMPcxy2xqc8FOHhvyYsr4UgMeta || {},
    component: () => import("/workspace/pages/fuhrpark/fuhrparkinfo.vue")
  },
  {
    name: "statistiken-produktiv___de",
    path: "/statistiken/produktiv",
    component: () => import("/workspace/pages/statistiken/produktiv.vue")
  },
  {
    name: "dashboard-telefonliste___de",
    path: "/dashboard/telefonliste",
    component: () => import("/workspace/pages/dashboard/telefonliste.vue")
  },
  {
    name: "digital-Lohnabrechnung___de",
    path: "/digital/Lohnabrechnung",
    component: () => import("/workspace/pages/digital/Lohnabrechnung.vue")
  },
  {
    name: "statistiken-pruefliste___de",
    path: "/statistiken/pruefliste",
    component: () => import("/workspace/pages/statistiken/pruefliste.vue")
  },
  {
    name: "dashboard-personalevent___de",
    path: "/dashboard/personalevent",
    component: () => import("/workspace/pages/dashboard/personalevent.vue")
  },
  {
    name: "digital-bewerber_Status___de",
    path: "/digital/bewerber_Status",
    component: () => import("/workspace/pages/digital/bewerber_Status.vue")
  },
  {
    name: "digital-bewerber-Tablets___de",
    path: "/digital/bewerber-Tablets",
    component: () => import("/workspace/pages/digital/bewerber-Tablets.vue")
  },
  {
    name: "digital-myTempton-urlaub___de",
    path: "/digital/myTempton-urlaub",
    component: () => import("/workspace/pages/digital/myTempton-urlaub.vue")
  },
  {
    name: "intern-PersonalAbteilung___de",
    path: "/intern/PersonalAbteilung",
    meta: PersonalAbteilung5l6EShvBGZNa1vbG7iDvIWQbOb14KsHRsHtqfUpvv4oMeta || {},
    component: () => import("/workspace/pages/intern/PersonalAbteilung.vue")
  },
  {
    name: "arbeitsplatz-besichtigung___de",
    path: "/arbeitsplatz/besichtigung",
    component: () => import("/workspace/pages/arbeitsplatz/besichtigung.vue")
  },
  {
    name: "dashboard-niederlassungen___de",
    path: "/dashboard/niederlassungen",
    component: () => import("/workspace/pages/dashboard/niederlassungen.vue")
  },
  {
    name: "digital-Bundeseinheitlich___de",
    path: "/digital/Bundeseinheitlich",
    meta: BundeseinheitlichyuT5hpzac0h0jXWCTzTMpTUMCeFwutBS7CPHgPphP8EMeta || {},
    component: () => import("/workspace/pages/digital/Bundeseinheitlich.vue")
  },
  {
    name: "digital-myTempton-Nutzung___de",
    path: "/digital/myTempton-Nutzung",
    component: () => import("/workspace/pages/digital/myTempton-Nutzung.vue")
  },
  {
    name: "intern-Personaluebersicht___de",
    path: "/intern/Personaluebersicht",
    meta: Personaluebersichts7gVvFMfXwK4a_45GIUayfgvU2UmVbh6N6uQFJSV2xpCYMeta || {},
    component: () => import("/workspace/pages/intern/Personaluebersicht.vue")
  },
  {
    name: "dashboard-arbeitszeitkonto___de",
    path: "/dashboard/arbeitszeitkonto",
    component: () => import("/workspace/pages/dashboard/arbeitszeitkonto.vue")
  },
  {
    name: "digital-bewerber_Uebersicht___de",
    path: "/digital/bewerber_Uebersicht",
    component: () => import("/workspace/pages/digital/bewerber_Uebersicht.vue")
  },
  {
    name: "digital-bewerber-Mitarbeiter___de",
    path: "/digital/bewerber-Mitarbeiter",
    component: () => import("/workspace/pages/digital/bewerber-Mitarbeiter.vue")
  },
  {
    name: "digital-Elektronischeanfrage___de",
    path: "/digital/Elektronischeanfrage",
    component: () => import("/workspace/pages/digital/Elektronischeanfrage.vue")
  },
  {
    name: "statistiken-werksarztzentrum___de",
    path: "/statistiken/werksarztzentrum",
    component: () => import("/workspace/pages/statistiken/werksarztzentrum.vue")
  },
  {
    name: "digital-myTempton-Transponder___de",
    path: "/digital/myTempton-Transponder",
    meta: myTempton_45TransponderK_NDtZDHWWEZMl_452XItEUlATidbLod9R7FteKc9SSWUMeta || {},
    component: () => import("/workspace/pages/digital/myTempton-Transponder.vue")
  },
  {
    name: "digital-tempton-connect-event___de",
    path: "/digital/tempton-connect-event",
    component: () => import("/workspace/pages/digital/tempton-connect-event.vue")
  },
  {
    name: "statistiken-vertriebsstatistik___de",
    path: "/statistiken/vertriebsstatistik",
    component: () => import("/workspace/pages/statistiken/vertriebsstatistik.vue")
  },
  {
    name: "statistiken-vertriebsvergleich___de",
    path: "/statistiken/vertriebsvergleich",
    component: () => import("/workspace/pages/statistiken/vertriebsvergleich.vue")
  },
  {
    name: "statistiken-vertriebuebersicht___de",
    path: "/statistiken/vertriebuebersicht",
    component: () => import("/workspace/pages/statistiken/vertriebuebersicht.vue")
  },
  {
    name: "digital-myTempton-zeiterfassung___de",
    path: "/digital/myTempton-zeiterfassung",
    component: () => import("/workspace/pages/digital/myTempton-zeiterfassung.vue")
  },
  {
    name: "statistiken-pruefliste_fehlerliste___de",
    path: "/statistiken/pruefliste_fehlerliste",
    component: () => import("/workspace/pages/statistiken/pruefliste_fehlerliste.vue")
  },
  {
    name: "digital-bewerber-Mitarbeiter_Einstell___de",
    path: "/digital/bewerber-Mitarbeiter_Einstell",
    component: () => import("/workspace/pages/digital/bewerber-Mitarbeiter_Einstell.vue")
  },
  {
    name: "digital-bewerber-Mitarbeiter_bewerbung___de",
    path: "/digital/bewerber-Mitarbeiter_bewerbung",
    component: () => import("/workspace/pages/digital/bewerber-Mitarbeiter_bewerbung.vue")
  }
]